/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventoTipoPratica } from './evento-tipo-pratica';


export interface TipoPraticaEventoComunicazioneListFilter { 
    evento?: EventoTipoPratica;
}



